// extracted by mini-css-extract-plugin
export default {"container":"fZ-z","title":"gZ-z","link":"hZ-z"};